import http from "./http";

export const fetchUsers = () => http.get("/users");
export const fetchSingleUser = (id) => http.get(`/users/${id}`)
export const regenerateVirtualAccount = (id) => http.post(`/users/virtual-account/${id}/regenerate`);
export const regenerateAllAccount = () => http.post(`/users/virtual-account/regenerate-all`);
export const suspendUser = (id) => http.patch(`/users/${id}/suspend`);
export const unsuspendUser = (id) => http.patch(`/users/${id}/unsuspend`)
export const verifyUserAccount = (id) => http.patch(`/users/${id}/verify-user`);